import { useState, useEffect } from 'react'
import useLocalStorageState from 'hooks/useLocalStorageState'

const JWT_LOCALSTORAGE_KEY = 'voice.portal.jwt'

class Unauthorized extends Error {}

export const request = (url, { fetchOptions = {} } = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    window.localStorage.getItem(JWT_LOCALSTORAGE_KEY)
  ) {
    fetchOptions = {
      ...fetchOptions,
      credentials: 'include',
      headers: {
        ...fetchOptions.headers,
        Authorization:
          'Bearer ' +
          JSON.parse(window.localStorage.getItem(JWT_LOCALSTORAGE_KEY)),
      },
    }
  }

  return fetch(
    (typeof window !== 'undefined'
      ? window.env.RAZZLE_API_BASE
      : 'https://system.voicearchive.com') + url,
    fetchOptions
  )
    .then((response) => {
      if (response.status == 401) {
        window.localStorage.removeItem(JWT_LOCALSTORAGE_KEY)
      }

      return response
    })
    .then((response) =>
      response.text().then(function (text) {
        return text ? JSON.parse(text) : null
      })
    )
}

export default function useApi(urlOrOptions = null, maybeOptions = {}) {
  const [options, setOptions] = useState(() => {
    if (typeof urlOrOptions !== 'string') {
      return { ...urlOrOptions, ...maybeOptions }
    }

    return { url: urlOrOptions, ...maybeOptions }
  })

  const [data, setData] = useState(null)
  const [meta, setMeta] = useState(null)
  const [errors, setErrors] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { load = true, url = null, json, then = () => {}, ...rest } = options
    let body = ''

    if (!load || !url) {
      return
    }

    setLoading(true)
    setErrors([])

    let fetchOptions = {
      ...rest,
    }

    if (json) {
      fetchOptions.body = JSON.stringify(json)
    }

    request(url, { fetchOptions })
      .then((result) => {
        if (!result) {
          setData(result)
          setErrors([])
          setMeta(null)
          return result
        }

        const { data, errors, success, meta } = result


        if (success) {
          setData(data)
        } else if (errors) {
          setErrors(errors)
        } else {
          setData(result)
        }

        setMeta(meta)
      })
      .then((result) => then(result))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false))
  }, [options])

  const refetch = (urlOrOptions = null, maybeOptions = {}) => {
    if (typeof urlOrOptions !== 'string') {
      setOptions((prevOptions) => ({
        ...prevOptions,
        ...urlOrOptions,
        ...maybeOptions,
        load: true,
      }))
    } else {
      setOptions((prevOptions) => ({
        ...prevOptions,
        url: urlOrOptions,
        ...maybeOptions,
        load: true,
      }))
    }
  }

  return [data, loading, errors, refetch, meta]
}
